'use client';
import { Trait, TraitToColumnMap } from '@baseball-near-you/common';
import type { Grade } from '@baseball-near-you/prisma';
import { Button, Separator } from '@baseball-near-you/ui';
import { useState } from 'react';
import { ReviewStep, useReviewContext } from '../AddReviewModal';
import { LetterGrade } from '../constants';
import { TeamGradeStar } from './TeamGradeStar';

export const DEFAULT_QUESTIONS = [
  {
    question: "How would you rate this team's facilities?",
    grade: LetterGrade.C,
  },
  {
    question: "How would you rate this team's coaching?",
    grade: LetterGrade.C,
  },
  {
    question: "How would you rate this team's location?",
    grade: LetterGrade.C,
  },
  {
    question: "How would you rate this team's community?",
    grade: LetterGrade.C,
  },
  {
    question: "How would you rate this team's overall experience?",
    grade: LetterGrade.C,
  },
];

export function GradeTeamForm() {
  const [grades, setGrades] = useState<Record<Trait, 1 | 2 | 3 | 4 | 5>>(
    Object.values(Trait).reduce(
      (acc, trait) => {
        acc[trait as Trait] = 3;
        return acc;
      },
      {} as Record<Trait, 1 | 2 | 3 | 4 | 5>
    )
  );

  const { team, setStep, setGrades: setContextGrades } = useReviewContext();

  return (
    <div>
      <div className="max-h-[75vh] overflow-y-scroll pb-4">
        <div className="flex flex-col space-y-5">
          {Object.values(Trait).map((trait) => {
            const grade = grades[trait];
            return (
              <div className="flex items-center justify-between" key={trait}>
                <p className="font-medium text-lg">{trait}</p>
                <div className="flex items-center gap-2">
                  {Array.from(Array(5), (_, i) => (
                    <button
                      type="button"
                      onClick={() => {
                        setGrades((prevGrades) => ({
                          ...prevGrades,
                          [trait]: i + 1,
                        }));
                      }}
                      key={`${trait}-star-${
                        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                        i
                      }`}
                    >
                      <TeamGradeStar
                        i={i}
                        grade={grade}
                        className="transition-colors hover:fill-red/50"
                      />
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Separator className="mb-2 w-full" />
      <Button
        className="mt-8 w-full"
        onClick={() => {
          if (!team?.id) return;
          const formattedGrades = Object.entries(grades).reduce(
            (acc, [trait, grade]) => {
              if (!TraitToColumnMap[trait as Trait]) {
                console.log('trait', trait);
                throw new Error('Invalid trait');
              }
              acc[TraitToColumnMap[trait as Trait]] = grade;
              return acc;
            },
            {} as Record<
              (typeof TraitToColumnMap)[keyof typeof TraitToColumnMap],
              number
            >
          );

          const gradesWithTeamId: Omit<Grade, 'id' | 'reviewId'> = {
            teamId: team.id,
            ...formattedGrades,
          };

          setContextGrades(gradesWithTeamId);
          setStep(ReviewStep.Tags);
        }}
      >
        Continue
      </Button>
    </div>
  );
}
